export default {
  async fetchDataForFilters({ state, commit }, { requestFunc, dataName, responseItemFormatter } = {}) {
    try {
      const response = await requestFunc()

      const items = response ? response.data.data.items : []
      if (typeof responseItemFormatter === 'function') {
        _.forEach(items, responseItemFormatter)
      }
      commit('setFiltersData', { key: dataName, value: items })
    } catch (e) {
      console.info(e)
    }
  },

  async fetchConfigForFilters({ state, commit }, { requestFunc, name }) {
    try {
      const response = await requestFunc()
      const items = response.data.data.filters
      commit('setFiltersConfig', { key: name, value: items })
    } catch (e) {
      console.info(e)
    }
  },
}
